import React, { useEffect, useState } from 'react';
import logo from "../../Assets/logoWhite.png";
import worldMap from "../../Assets/world-map.png";
import ReactTextTransition, { presets } from "react-text-transition";
import style from './style.module.scss';
import { Link } from 'react-router-dom';

function LandingPage() {
    const [index, setIndex] = useState(0);
    const texts = [
        "Story",
        "Moments",
        "Tought",
        "NFTs"
    ]
    useEffect(() => {
        let myInterval = setInterval(() => setIndex(index+1), 2000);
        return () => {
            clearInterval(myInterval);
        };
    })
  return (
    <div className={style.parents}>
        <div className={style.background}>
            <img className={style.backgroundImg} src={worldMap} alt='background'/>
        </div>
        <div className={style.container}>
            <div className={style.branding}>
                <img src={logo} className={style.logoBrand} alt='logo'/>
            </div>
            <div className={style.textContainer}>
                <h1>Everyone Has a Story</h1>
                <section className={`inline ${style.movingText}`}>
                    Create and Share 
                    <ReactTextTransition
                    springConfig={presets.gentle}
                    style={{ margin: "0 4px" }}
                    inline
                    >
                    {texts[index % texts.length]}
                    </ReactTextTransition>
                    .
                </section>
            </div>
            <Link to={'/login'} className={style.btnRedirect}>Sign in</Link>
        </div>
    </div>
  )
}

export default LandingPage;